<save-page pageTitle="Reports"
           [tabSetConfig]="tabSetConfig">
</save-page>
